package com.iregained.eventapp

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.iregained.eventapp.utils.LocalBreakpoint
import com.iregained.eventapp.utils.rememberBreakpoint
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.vh
import kotlin.time.Duration.Companion.milliseconds

private const val COLOR_MODE_KEY = "eventapp:colorMode"

// This runs before the Compose application even starts mounting
@InitKobweb
fun initFirebase(ctx: InitKobwebContext) {
    try {
        val hostname = window.location.hostname
        if (hostname.contains("event.iregained.rehab") || hostname.contains("events.iregained.rehab") || hostname.contains("localhost")) {
            val options = FirebaseOptions(
                applicationId = "1:330703191152:web:10057e5b655e2bb45cc8b5",
                apiKey = "AIzaSyByHZVO8mIpTwu6aLiP49g1gaWoSKWa6Mg",
                projectId = "ir-event-management",
                authDomain = "ir-event-management.firebaseapp.com",
                storageBucket = "ir-event-management.firebasestorage.app"
            )
            Firebase.initialize(options = options)
        }
    } catch (e: Exception) {
        console.error("Firebase initialization failed:", e)
    }
}

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.styleModifier {
            property("color-scheme", "light")
        }
    }

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.scrollBehavior(ScrollBehavior.Smooth)
    }
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.apply {
        registerStyleBase("body") { Modifier.scrollBehavior(ScrollBehavior.Smooth) }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        var colorMode by ColorMode.currentState

        // Track the screen size globally
        val breakpoint by rememberBreakpoint()

        LaunchedEffect(Unit) {
            kotlinx.coroutines.delay(300.milliseconds)
            document.documentElement?.classList?.remove("preloader-active")
        }

        // Provide the breakpoint to the entire app!
        CompositionLocalProvider(LocalBreakpoint provides breakpoint) {
            Surface(
                SmoothColorStyle.toModifier().minHeight(100.vh).fillMaxWidth()
            ) {
                content()
            }
        }
    }
}
